import { getSessionUserInformation } from "app/utils/utility.service";
import { getSessionClientInformation } from "app/utils/utility.service";
import RestClient from "RestClient";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const restClient = new RestClient();

export const updateRentDownPayment = async (payload, userId) => {
    const result = await restClient.put(`${BASE_URL}/users/${userId}`,payload);
    return result;
}


export const insertUpdateMonthlyExpenses = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/monthlyexpenses/create`,payload);
    return result?.data;
}

export const getMonthlyExpenses = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/monthlyexpenses/${payload.userId}`,[]);
    return result?.data; 
}


export const getIncomeCalculations = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/incomecalculations/${payload.userId}`,[]);
    return result?.data; 
}

export const getMortgageStructureDebts = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/mortgagedebts/${payload.userId}`,[]);
    return result?.data; 
}

export const getMortgageStructureDirectIncome = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/mortgagedirectincomes/${payload.userId}`,[]);
    return result?.data; 
}
export const getMortgageStructureIndirectIncome = async (payload) => {
    const result = await restClient.get(`${BASE_URL}/mortgageindirectincomes/${payload.userId}`,[]);
    return result?.data; 
}

export const insertUpdateIncomeCalculations = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/incomecalculations/create`,payload);
    return result?.data;
}

export const insertUpdateMortgageDebtCalculations = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/mortgagedebts/create`,payload);
    return result?.data;
}
export const insertUpdateMortgageDirectIncomeCalculations = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/mortgagedirectincomes/create`,payload);
    return result?.data;
}
export const insertUpdateMortgageIndirectIncomeCalculations = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/mortgageindirectincomes/create`,payload);
    return result?.data;
}

export const insertSettings = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/settings/create`,payload);
    return result;
}

export const updateSettings = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/settings/${payload.userId}`,payload);
    return result;
}

export const insertRentalIncome = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/rentalincomes/create`,payload);
    return result?.data;
}

export const updateRentalIncome = async (id, payload) => {
    const result = await restClient.put(`${BASE_URL}/rentalincomes/${id}`,payload);
    return result?.data;
}

export const getRentalList = async (payload) =>{
    const result = await restClient.get(`${BASE_URL}/rentalincomes/${payload.userId}`,[]);
    return result?.data; 
}

export const deleteRentalRecord = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/rentalincomes/${id}`);
    return result?.data; 
}

export const getClientSetting = async(payload) => {
    const result = await restClient.get(`${BASE_URL}/settings/${payload}`,[]);
    return result?.data; 
}


export const getClientUser = async(payload) => {
    const result = await restClient.get(`${BASE_URL}/users/${payload}`,[]);
    return result?.data; 
}

export const insertLogs = async (payload) => {
    const sessionValues = getSessionUserInformation();
    const clientSessionValues = getSessionClientInformation();
    if(!!clientSessionValues?.id) {
        payload.userId = clientSessionValues?.id;
    } else {
        payload.userId = sessionValues?.id;
    }
    payload.updatedBy = sessionValues.id;
    payload.brokerId = sessionValues?.brokerId ? sessionValues?.brokerId : null;
    payload.agentId = sessionValues?.agentId ? sessionValues?.agentId : null;
    const result = await restClient.post(`${BASE_URL}/logs/create`,payload);
    return result?.data;
}

export const insertAssumptions = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/assumptions/create`,payload);
    return result;
}

export const updateAssumptions = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/assumptions/${payload.userId}`,payload);
    return result;
}

export const getUserAssumptions = async (payload) =>{
    const result = await restClient.get(`${BASE_URL}/assumptions/${payload.userId}`,[]);
    return result?.data; 
}


export const insertInvestmentAnalysis = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/investment-analysis/create`,payload);
    return result;
}

export const updateInvestmentAnalysis = async (payload) => {
    const result = await restClient.put(`${BASE_URL}/investment-analysis/${payload.userId}`,payload);
    return result;
}

export const getInvestmentAnalysis = async (payload) =>{
    const result = await restClient.get(`${BASE_URL}/investment-analysis/${payload.userId}`,[]);
    return result?.data; 
}

export const getCurrentUser = async(userId) => {
    const result = await restClient.get(`${BASE_URL}/users/${userId}`,[]);
    return result?.data; 
}
export const getCurrentUserSettings = async(userId) => {
    const result = await restClient.get(`${BASE_URL}/settings/${userId}`,[]);
    return result?.data; 
}
export const getPropertyDetails = async(userId) => {
    const result = await restClient.get(`${BASE_URL}/portfolios?userId=${userId}`,[]);
    return result?.data; 
}
export const addPropertyDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/portfolios/create`,payload);
    return result?.data;
}
export const editPropertyDetails = async (payload,userId) => {
    const result = await restClient.put(`${BASE_URL}/portfolios/${userId}`,payload);
    return result;
}
export const getSinglePropertyDetails = async (propertyId) => {
    const result = await restClient.get(`${BASE_URL}/portfolios/${propertyId}`,[]);
    return result?.data;
}
export const deleteSinglePropertyDetails = async (propertyId,userId,addressOne) => {
    const result = await restClient.delete(`${BASE_URL}/portfolios/${propertyId}?userId=${userId}&addressOne=${addressOne}`,[]);
    return result;
}
export const getReminderDetails = async (userId,reminderType,propertyId) => {
    const result = await restClient.get(`${BASE_URL}/reminders/?userId=${userId}&reminder_type=${reminderType}&property_id=${propertyId}`,[]);
    return result?.data;
}
export const editReminderDetails = async (payload,hoaID) => {
    const result = await restClient.put(`${BASE_URL}/reminders/${hoaID}`,payload);
    return result;
}
export const deleteReminderDetails = async (hoaId) => {
    const result = await restClient.delete(`${BASE_URL}/reminders/${hoaId}`,[]);
    return result;
}
export const addReminderDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/reminders/create`,payload);
    return result;
}
export const getWorkHistoryDetails = async (userId,propertyId) => {
    const result = await restClient.get(`${BASE_URL}/workpermits/?userId=${userId}`,[]);
    return result?.data;
}
export const editWorkHistoryDetails = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/workpermits/${id}`,payload);
    return result?.data;
}
export const deleteWorkHistoryDetails = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/workpermits/${id}`,[]);
    return result;
}
export const addWorkHistoryDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/workpermits/create`,payload);
    return result?.data;
}
export const getPaymentDetails = async (userId,propertyId) => {
    const result = await restClient.get(`${BASE_URL}/payments/?userId=${userId}`,[]);
    return result?.data;
}
export const editPaymentDetails = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/payments/${id}`,payload);
    return result?.data;
}
export const deletePaymentDetails = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/payments/${id}`,[]);
    return result;
}
export const addPaymentDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/payments/create`,payload);
    return result?.data;
}
export const generateUserPaymentReport = async (userId,startDate,endDate,propertyId) => {
    const result = await restClient.get(`${BASE_URL}/payments/generateUserPaymentReport?userId=${userId}&startDate=${startDate}&endDate=${endDate}&property_id=${propertyId}`,[]);
    return result?.data;
}
export const generateBreakdownReport = async (userId,startDate,endDate,propertyId,preventive) => {
    const result = await restClient.get(`${BASE_URL}/workpermits/generateBreakdownReport?userId=${userId}&startDate=${startDate}&endDate=${endDate}&property_id=${propertyId}&preventive=${preventive}`,[]);
    return result?.data;
}
export const calculatePropertyIncome = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/accounts/calculatePropertyIncome/${userId}`,[]);
    return result?.data;
}
export const saveLoans = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/loans/create`,payload);
    return result?.data;
}
export const getLoanDetails = async (userId,propertyId) => {
    const result = await restClient.get(`${BASE_URL}/loans/get/?userId=${userId}&property_id=${propertyId}`,[]);
    return result?.data;
}
export const editLoanSchedule = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/loans/${id}`,payload);
    return result?.data;
}
export const getFinancials = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/financials?userId=${userId}`,[]);
    return result?.data;
}
export const deleteFinancials = async (id,userId) => {
    const result = await restClient.delete(`${BASE_URL}/financials/${id}?userId=${userId}`);
    return result?.data;
}
export const addFinancials = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/financials/create`,payload);
    return result;
}
export const editFinancials = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/financials/${id}`,payload);
    return result;
}
export const getCommodities  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/commodities?userId=${userId}`,[]);
    return result?.data;
}
export const deleteCommodities = async (id,userId) => {
    const result = await restClient.delete(`${BASE_URL}/commodities/${id}?userId=${userId}`);
    return result?.data;
}
export const addCommodities = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/commodities/create`,payload);
    return result;
}
export const editCommodities = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/commodities/${id}`,payload);
    return result;
}
export const getCrypto  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/cryptocurrency?userId=${userId}`,[]);
    return result?.data;
}
export const deleteCrypto = async (id,userId) => {
    const result = await restClient.delete(`${BASE_URL}/cryptocurrency/${id}?userId=${userId}`);
    return result?.data;
}
export const addCrypto = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/cryptocurrency/create`,payload);
    return result;
}
export const editCrypto = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/cryptocurrency/${id}`,payload);
    return result;
}
export const createAccounts = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/accounts/create`,payload);
    return result?.data;
}
export const getAccounts = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/accounts?userId=${userId}`,[]);
    return result?.data;
}
export const addAssets = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/accounts/createAsset`,payload);
    return result?.data;
}
export const addSubCategories = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/accounts/createSubCategory`,payload);
    return result?.data;
}
export const deleteSubCategories = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/accounts/${id}`,[]);
    return result?.data;
}
export const deleteAccounts = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/accounts/category/${id}`,[]);
    return result?.data;
}
export const editCategoryName = async (id,payload) => {
    const result = await restClient.put(`${BASE_URL}/accounts/${id}`,payload);
    return result?.data;
}
export const editSubcategory = async (id,payload) => {
    const result = await restClient.put(`${BASE_URL}/accounts/category/${id}`,payload);
    return result?.data;
}
export const deleteCategories = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/accounts/category/${id}`,[]);
    return result?.data;
}
export const getNetworthProjectionValues = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/accounts/netWorthValues/${userId}`,[]);
    return result?.data;
}
export const getCommoditiesStats = async (id) => {
    const result = await restClient.get(`${BASE_URL}/commodities/stats/${id}`,[]);
    return result?.data;
}
export const getCryptoStats = async (id) => {
    const result = await restClient.get(`${BASE_URL}/cryptocurrency/stats/${id}`,[]);
    return result?.data;
}
export const getFinancialsStats = async (id) => {
    const result = await restClient.get(`${BASE_URL}/financials/stats/${id}`,[]);
    return result?.data;
}
export const getFinancialsTotalPurchasePrice = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/financials/getTotalPurchasePrice/${userId}`,[]);
    return result?.data;
}

export const getFirstPropertyPP = async (id) => {
    const result = await restClient.get(`${BASE_URL}/portfolios/getFirstPropertyPurchasePrice/${id}`,[]);
    return result?.data;
}
export const getCommoditiesTotalPurchasePrice = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/commodities/getTotalPurchasePrice/${userId}`,[]);
    return result?.data;
}

export const getCryptoTotalPurchasePrice = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/cryptocurrency/getTotalPurchasePrice/${userId}`,[]);
    return result?.data;
}


export const getLifeEventDetails  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/userlifeevents/?userId=${userId}`,[]);
    return result?.data;
}

export const editLifeEventDetails = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/userlifeevents/${id}`,payload);
    return result?.data;
}
export const deleteLifeEventDetails = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/userlifeevents/${id}`,[]);
    return result;
}
export const addLifeEventDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/userlifeevents/create`,payload);
    return result?.data;
}
export const getLifeEventData  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/lifeevents/`,[]);
    return result?.data;
}
export const getDepletionDetails  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/depletions/?userId=${userId}`,[]);
    return result?.data;
}
export const getDepletionDetailsByUserId  = async (userId) => {
    const result = await restClient.get(`${BASE_URL}/depletions/getByUserId/${userId}`,[]);
    return result?.data;
}
export const getDepletionDetailsByAsset = async (userId,name) => {
    const result = await restClient.get(`${BASE_URL}/depletions/get/?userId=${userId}&name=${name}`,[]);
    return result?.data;
}
export const editDepletionDetails = async (payload,id) => {
    const result = await restClient.put(`${BASE_URL}/depletions/${id}`,payload);
    return result?.data;
}
export const deleteDepletionDetails = async (id) => {
    const result = await restClient.delete(`${BASE_URL}/depletions/${id}`,[]);
    return result;
}
export const addDepletionDetails = async (payload) => {
    const result = await restClient.post(`${BASE_URL}/depletions/create`,payload);
    return result?.data;
}

export const getPortfolioPurchasePrice = async (id) => {
    const result = await restClient.get(`${BASE_URL}/portfolios/getTotalPurchasePrice/${id}`,[]);
    return result?.data;
}